
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

import { BeesFooterComponent } from '../bees-footer/bees-footer.component';
import { BeesHeaderComponent } from '../bees-header/bees-header.component';

@Component({
  selector: 'app-page-gallery',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    BeesFooterComponent,
    BeesHeaderComponent
  ],
  templateUrl: './page-gallery.component.html',
  styleUrl: './page-gallery.component.scss'
})
export class PageGalleryComponent {

  // Gallery images: team-2-1.jpg to team-2-32.jpg
  galleryImages: number[] = Array.from(
    { length: 32 },
    (_, index) => index + 1
  );

}
